export default __webpack_public_path__ + "static/media/simulation-active.ae406094.svg";